import { Step } from '@/util/Step';
import { PaymentMethodDto } from '@/api';

export const delivery = {
  type: {
    pickUp: 'Abholung',
    delivery: 'Lieferung',
  },
  header: {
    pickUp: 'in',
    delivery: 'nach',
    summary: ' {location}, {time}',
    deadlineLabel: 'Bestellen Sie bis',
    deadlineCloseLabel: 'Bestellen Sie innerhalb der nächsten',
    deadlineCloseMinutes: '{minutes} Minuten',
    selectLine1: 'Bitte wählen',
    selectLine2: 'Sie zwischen',
  },
};

export const order = {
  step: {
    [Step.ADDRESS]: 'Rechnungs- und Lieferadresse',
    [Step.DELIVERY]: 'Versand',
    [Step.PAYMENT]: 'Zahlungsart',
    [Step.SUMMARY]: 'Zusammenfassung',
  },
  actionComplete: 'Zahlungspflichtig bestellen',
  actionNext: 'Weiter',
  cardHolderError: 'Ungültiger Karteninhaber',
  address: {
    newAddress: 'Fügen Sie eine neue Adresse hinzu',
    noAddresses: 'Mit Ihrem Konto ist aktuell keine Adresse verknüpft. Bitte legen Sie in Ihrem Profil eine ' +
      'Adresse an, bevor Sie bestellen.',
    goToProfile: 'Adresse anlegen',
    sameAddress: 'Die Lieferadresse ist gleich der Rechnungsadresse',
    alternativeAddress: 'Eine alternative Lieferadresse wählen',
    changeAddress: 'Adresse ändern',
    doneChange: 'Fertig',
  },
  paymentMethod: {
    [PaymentMethodDto.CASH]: 'Bezahlung bei Abholung/Zustellung. Bargeld oder Kartenzahlung möglich',
    [PaymentMethodDto.PAYPAL]: 'PayPal',
    [PaymentMethodDto.CREDITCARD]: 'Kreditkarte',
    [PaymentMethodDto.SOFORT]: 'Sofortüberweisung',
  },
  transaction: {
    descriptions: {
      creditCard: 'Bezahlung mit Kreditkarte',
      paypal: 'Bezahlung mit PayPal.\n ' +
        'Mit Klick auf den Button werden Sie automatisch zu PayPal weitergeleitet. ' +
        'Loggen Sie sich direkt in Ihrem PayPal-Konto ein und bestätigen Sie die Bezahlung.',
      sofort: 'Bezahlung mit Sofort',
      error: 'Leider ist ein Fehler aufgetreten. Bitte kehren Sie zur vorherigen Seite zurück und wiederholen Sie Ihre Auswahl',
    },
    price: 'Betrag: {price} €',
    cancelHeader: 'Transaktion abbrechen',
    cancelDescription: 'Möchten sie die Transaktion wirklich abbrechen?',
  },
  delivery: {
    header: 'Versand',
    delivery: 'Lieferung',
    pickup: 'Abholung',
    chooseDelivery: 'Versandart wählen',
    place: 'Ort',
    deliveryPlace: 'Lieferort',
    chooseDeliverySlot: 'Wählen Sie den gewünschten Liefertermin.',
    choosePickupSlot: 'Wählen Sie den frühestmöglichen Abholtermin.',
    notInDeliveryArea: 'Ihre PLZ liegt derzeit leider nicht in unserem Liefergebiet - bitte wählen Sie \"Abholung\".',
    noPostCode: 'Bitte geben Sie oben rechts Ihre PLZ ein, um Liefertermine abzufragen.',
    driverNotice: 'Anmerkung für den Zustellfahrer',
    driverNoticePlaceholder: 'zB Klingel defekt, bitte an Haustüre klopfen',
    myAddresses: 'Meine Adressen',
    select: 'Wählen',
    pickupExplainer: {
      wrapper: 'Bitte wählen Sie Datum und Uhrzeit an dem Sie Ihren bereitgestellten Einkauf {location} abholen ' +
        'möchten. Das ausgewählte Zeitfenster bestimmt die frühestmögliche Abholzeit. Der Einkauf kann am ' +
        'gewählten Tag jedenfalls {deadline} abgeholt werden.',
      hidden: 'Informationen anzeigen',
    },
    calendar: {
      today: 'heute',
      tomorrow: 'morgen',
      now: 'Jetzt',
      weekday: {
        1: 'Montag',
        2: 'Dienstag',
        3: 'Mittwoch',
        4: 'Donnerstag',
        5: 'Freitag',
        6: 'Samstag',
        7: 'Sonntag',
      },
    },
  },
  confirmation: {
    thankYouNote: 'Vielen Dank für Ihren Einkauf!',
    emailNote: 'Sie werden in Kürze eine Bestellbestätigung per E-Mail erhalten.',
    orderNumber: 'Ihre Bestellnummer lautet',
    failed: 'Bei der Bezahlung Ihrer Bestellung ist ein Fehler aufgetreten.',
    retry: 'Zahlung erneut versuchen',
    askCustomerService: 'Oder wenden Sie sich an den Kundenservice.',
  },
  summary: {
    header: 'Zusammenfassung',
    billingAddress: 'Rechnungsaddresse',
    mailTo: 'Bestätigungsmail an',
    telephone: 'Telefonnummer',
    deliveryAddress: 'Lieferadresse',
    paymentMethod: 'Zahlungsart',
  },
};
